import MailchimpForm from '../../../components/MailchimpForm/MailchimpForm'

export default function Newsletter (props = {
    heading: null,
    text: null,
    mailchimpForm: null,
    img: {
        src: null,
        alt: null,
        width: null,
        height: null,
        style: null
    }
}) {
    const mailchimpForm = props.mailchimpForm || {}

    if (!mailchimpForm.action
            || !mailchimpForm.userId
            || !mailchimpForm.listId
            || !mailchimpForm.formId)
        return null

    return (
        <section className="newsletter pad-section">
            <div className="container">
                <div className="row flex-justify-content-center">
                    <div className="col-12 col-10-xl-up">
                        <div className="newsletter card pad-0">
                            <div className="row">
                                {props.img
                                    && props.img.src
                                    && (
                                        <div className="col-12 col-5-md-up pad-0-r-md-up display-flex flex-direction-column">
                                            <div className="ratio-wide-md-down flex-grow">
                                                <img
                                                    src={props.img.src}
                                                    alt={props.img.alt || ''}
                                                    width={props.img.width}
                                                    height={props.img.height}
                                                    data-object-fit="cover"
                                                    data-object-position={props.img.style
                                                        && props.img.style.objectPosition}
                                                    style={props.img.style}
                                                />
                                            </div>
                                        </div>)}
                                <div className="col col-12-md-down pad-4-r pad-4-l-md-down display-flex flex-direction-column">
                                    <div className="row flex-justify-content-center flex-align-items-center flex-grow">
                                        <div className="col-12 col-10-md-up col-8-xl-up pad-3-t pad-b pad-5-t-md-up pad-5-b-md-up">
                                            {props.heading
                                                && (
                                                    <h2 className="heading-6 typography-no-breakpoints margin-b">
                                                        {props.heading}
                                                    </h2>)}
                                            <MailchimpForm {...mailchimpForm} />
                                            {props.text
                                                && (
                                                    <p className="body-4 col-9 col-7-sm col-12-md col-9-lg col-7-xl-up pad-0 margin-1-t">
                                                        {props.text}
                                                    </p>)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
